export const importantEventDTOFields = {
    id: 'id',
    journalId: 'journalId',
    name: 'name',
    date: 'date',
    description: 'description',
} as const;
